(ns frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.toc-page
  (:require
   [clojure.string :as s]
   [frontend.ui.style.theme.core :as theme]
   [frontend.utils :as fu]
   [reagent.dom.server :as r]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]))

(defn toc-page
  [{:keys [cover-image report-data line-height]}]
  (let [toc-text-margin-x 30
        toc-text-margin-y 30
        line-height 0.7
        toc-text-width (- page/page-width (* 2 toc-text-margin-x))]
    [(page/page
      "TOC"
      {:stack [{:absolutePosition {:x 0 :y 0}
                :image cover-image
                :width (cond (= (theme/get-theme) :theme.lp-portal/reindeer-partners)
                             1920
                             :else
                             1080)}
               {:absolutePosition {:x 50 :y 50}
                :stack [{:svg    (theme/svg-logo-light)
                         :fit    [260 75]
                         :margin [0 0 0 16]}
                        {:text     (s/upper-case (or (:fund-name report-data) ""))
                         :fontSize 14
                         ;:bold     true
                         :color    (theme/color [:pdf :landing-page :text])
                         :margin   [0 0 0 12]}
                        {:text     (-> report-data
                                       :reference-date
                                       (fu/format-date-ts "." true)
                                       (or "")
                                       (s/upper-case))
                         :fontSize 14
                         ;:bold     true
                         :color    (theme/color [:pdf :landing-page :text])}]}]})
     (page/page (page/page-title-with-line {:fund-name  (:fund-name report-data)
                                            :page-title "Table of contents"
                                            :toc-item   false})
                {:stack [{:absolutePosition {:x toc-text-margin-x
                                             :y toc-text-margin-y}
                          :columns [{:color      (theme/color [:pdf :toc :text])
                                     :lineHeight (or line-height 1.65)
                                     :toc        {:title {:text     ""
                                                          :margin   [0 0 0 20]
                                                          :fontSize 6
                                                          :bold     true}
                                                 }
                                     :fontSize   7 ;;TODO dynamic font size
                                     :width      toc-text-width}
                                   ]}]})]))
